// This function is in a separate file to allow for mocking in unit tests
export default function () {
    return 'scrollBehavior' in document.documentElement.style;
}
//# sourceMappingURL=native-smooth-scroll-supported.js.map